import { Trans, useTranslation } from 'react-i18next';

import { useValidUntil } from '../utils/useValidUntil';

import { makeStyles } from '@egr/xbox/utils/tss-react';

const useStyles = makeStyles({ name: 'ViewerContainer' })((theme) => ({
    valid: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        backgroundColor: theme.palette.secondary.light,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 14,
        paddingRight: 14,
        color: 'white',
        fontSize: 11,
        fontWeight: 400,
    },
}));

export const Valid: React.FC = () => {
    const { classes } = useStyles();
    const [t] = useTranslation();
    const validUntil = useValidUntil();

    if (!validUntil) {
        return;
    }

    return (
        <div
            id="valid"
            className={classes.valid}
        >
            <Trans t={t} i18nKey="Available until: <1>{{validUntil}}</1>" values={{ validUntil }} components={{ 1: <b /> }} />
        </div>
    );
};
